var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76884 5C10.5072 5 13.5374 8.05143 13.5374 11.8153C13.5374 15.5792 10.5069 18.6303 6.76884 18.6303C3.03073 18.6303 0 15.5792 0 11.8153C0 8.05143 3.0305 5 6.76884 5ZM17.5782 5.39922C19.4474 5.39922 20.9626 8.2715 20.9626 11.8153H20.9628C20.9628 15.3582 19.4476 18.2314 17.5784 18.2314C15.7092 18.2314 14.194 15.3582 14.194 11.8153C14.194 8.27242 15.709 5.39922 17.5782 5.39922ZM22.8097 6.0675C23.4669 6.0675 24 8.64083 24 11.8153C24 14.9888 23.4672 17.5631 22.8097 17.5631C22.1522 17.5631 21.6196 14.9895 21.6196 11.8153C21.6196 8.64106 22.1524 6.0675 22.8097 6.0675Z",
    fill: "#6E7484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.6517acd3814bcebb80fc55ca4d507088.svg";
export { ForwardRef as ReactComponent };